window.dataLayer = window.dataLayer || [];

const { getUrlParameter } = require('./adqlo-public');
const { loadingPage } = require('./adqlo-loading');
const { formatDate } = require('./adqlo-public');

$(document).ready(function() {
    // based on env EXPRESS_REPORT_PHASE to debug owl carousel dots
    /**$(document).on("DOMNodeInserted", function(e) {
        if ($(e.target).is(".owl-dot")) {
            if ($("#pay").length > 0) {
                $(".owl-dot:first").addClass("clickable");
            }
            if (phase == 0) {
                if ($("#start").length > 0) {
                    $(".owl-dot").addClass("switch");
                }
                if ($("#pay").length > 0) {
                    $(".owl-dot").addClass("switch");
                }
            } else if (phase == 1) {
                if ($("#start").length > 0) {
                    $(".owl-dot").removeClass("switch");
                }
                if ($("#pay").length > 0) {
                    $(".owl-dot").addClass("switch");
                }
            } else if (phase == 2) {
                if ($("#start").length > 0) {
                    $(".owl-dot").addClass("switch");
                }
                if ($("#pay").length > 0) {
                    $(".owl-dot").removeClass("switch");
                }
            }
        }
    });**/
    // fix deprecated DOMNodeInserted
    const observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                $(mutation.addedNodes).each(function() {
                    if ($(this).is(".owl-dot")) {
                        // console.log('EXPRESS_REPORT_PHASE:', phase);
                        if ($("#pay").length > 0) {
                            $(".owl-dot:first").addClass("clickable");
                        }
                        if (phase == 0) {
                            if ($("#start").length > 0) {
                                $(".owl-dot").addClass("switch");
                            }
                            if ($("#pay").length > 0) {
                                $(".owl-dot").addClass("switch");
                            }
                        } else if (phase == 1) {
                            if ($("#start").length > 0) {
                                $(".owl-dot").removeClass("switch");
                            }
                            if ($("#pay").length > 0) {
                                $(".owl-dot").addClass("switch");
                            }
                        } else if (phase == 2) {
                            if ($("#start").length > 0) {
                                $(".owl-dot").addClass("switch");
                            }
                            if ($("#pay").length > 0) {
                                $(".owl-dot").removeClass("switch");
                            }
                        }
                    }
                });
            }
        });
    });
    // Start observing the document's body for child node additions
    observer.observe(document.body, { childList: true, subtree: true });

    function updateExpressReportId() {
        var report_id = getUrlParameter('id');

        // Check if the URL has 'id' parameter and if the input field is empty
        if (report_id && $('#report_id').val() === '') {
            $('#report_id').val(report_id);
        } else if ($('#report_id').val() !== '') {
            clearInterval(interval); // Stop the interval when input has a value
        }
    }

    // Call the function immediately to update the input initially
    updateExpressReportId();

    // Set an interval to call the function every second
    var interval = setInterval(updateExpressReportId, 1000);

    const carousel = $('.owl-carousel');

    carousel.owlCarousel({
        items: 1,
        loop: false,
        nav: false,
        dots: true,
        mouseDrag: false, // Disable dragging
        touchDrag: false, // Disable dragging on touch devices
    });

    // when input changes remove error message
    $('input').on('input', function() {
        $(this).removeClass('is-invalid');
    });

    $('.slide-form').submit(function(e) {
        e.preventDefault();
        // Check if any element inside the form has the "is-invalid" class
        if ($(this).find(".is-invalid").length > 0) {
            alert("Please correct the errors before submitting the form.");
        } else {
            $('.btn-form-save').prop('disabled', true);
            $('.btn-form-save').html('<i class="fa fa-spinner fa-pulse"></i> Loading');
            var form_data = new FormData(this);
            var action_url = $(this).attr('action');
            var currentSlideClass = $('.owl-item.active').find('.item').attr('class').split(' ')[1]; // Get the class of the current slide

            $.ajax({
                type: 'POST',
                url: action_url,
                headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
                data: form_data,
                processData: false,
                contentType: false,
                success: function(data) {
                    $('.btn-form-save').prop('disabled', false);
                    $('.btn-form-save').html('Continue');

                    var targetSlideIndex = -1;
                    // Loop through each slide item to find the target slide index
                    $('.owl-item').each(function(index) {
                        // Get the class of the current slide
                        var slideClass = $(this).find('.item').attr('class').split(' ')[1];
                        if (slideClass === data.data.redirect_item_id) {
                            targetSlideIndex = index;
                            return false; // Exit the loop
                        }
                    });
                    // If a valid target slide index is found, trigger the carousel to move to that slide
                    if (targetSlideIndex !== -1) {
                        carousel.trigger('to.owl.carousel', targetSlideIndex);
                    } else {
                        // Handle when the target slide is not found
                    }

                    if (data.data.current_item_id == 'item-2') { //register page
                        // reset values
                        $("#first_name").val("");
                        $("#last_name").val("");
                        $("#email").val("");
                        $("#phone").val("");
                        $('#register_error_message').text("");

                        if (data.data.success == false) {
                            $('#register_error_message').text(data.data.message);

                        } else {
                            // redirect to price page
                            if (data.data.redirect_url !== undefined) {
                                window.location.href = data.data.redirect_url;
                            } else {
                                // add gtm Adqlo Free Report Sign Up , event : "Adqlo Free Report Sign Up"
                                window.dataLayer.push({'event': 'Adqlo Free Report Sign Up'});

                                // add report id into url param /free?id=XXX#start
                                var report_id = data.data.id;
                                if ( report_id !== undefined ) {
                                    // Get the base URL without query parameters and hash fragment
                                    var base_url = document.location.origin + document.location.pathname;

                                    // Construct the URL with the report_id parameter in the path and hash fragment
                                    var url = base_url + '?id=' + report_id + '#start';

                                    // Update the browser's history state without refreshing the page
                                    history.pushState(null, '', url);
                                }

                                // add email into verify_report_email
                                var email = data.data.client.email;
                                if ( email !== undefined ) {
                                    $('#verify_report_email').text(email);
                                } else {
                                    $('#verify_report_email').text('N/A');
                                }

                                // whitelist will redirect from register page to loading page
                                if (data.data.redirect_item_id == 'item-4') {
                                    var first_name = data.data.client.first_name;
                                    if ( first_name !== undefined ) {
                                        $('#loading_report_first_name').text(first_name);

                                        loadingPage();
                                    } else {
                                        $('#loading_report_first_name').text('N/A');
                                    }
                                }
                            }
                        }
                    }

                    // add first name into loading_report_first_name
                    if (data.data.current_item_id == 'item-3') { //verify page
                        // reset values
                        $("#otp-1").val("");
                        $("#otp-2").val("");
                        $("#otp-3").val("");
                        $("#otp-4").val("");
                        $('#verify_error_message').text("");
                        $('#verify_success_message').text("");

                        if (data.data.success == false) {
                            $('#verify_error_message').text(data.data.message);
                        } else {
                            // add gtm Adqlo Free Report Sign Up Verified, event : "Adqlo Free Report Sign Up Verified"
                            window.dataLayer.push({'event': 'Adqlo Free Report Sign Up Verified'});
                            
                            var first_name = data.data.client.first_name;
                            if ( first_name !== undefined ) {
                                $('#loading_report_first_name').text(first_name);

                                loadingPage();
                            } else {
                                $('#loading_report_first_name').text('N/A');
                            }
                        }
                    }

                    if (data.data.current_item_id == 'item-4') { //payment page
                        if (data.data.success == true && data.data.report_price) {
                            // $("#btn_apply_voucher").text('Applied').prop('disabled', true);
                            $('.btn-form-save').html('Apply');
                            $('#voucher_code').val(data.data.voucher_code);
                            $('#voucher_value').text(data.data.voucher_value);
                            $('#report_price').text(data.data.report_price);
                            $('#after_discount_price').text(data.data.after_discount_price);
                            if (data.data.after_discount_price == 0) {
                                // var lastUpdatedTime = new Date(); 
                                // $('#last_updated_time').text(formatDate(lastUpdatedTime));
                                // $('#btn_paid').removeClass('d-none');
                                // $('#text_updated_time').removeClass('d-none');
                            }
                        }
                    }
                },
                error:function(xhr, textStatus, errorThrown){
                    var data = xhr.responseJSON
                    if (data && data.data && data.data.current_item_id) {
                        var currentItemId = data.data.current_item_id;
                        var message = data.data.message;

                        if (currentItemId === 'item-2') { // Register page
                            $('#register_error_message').text(message);
                        } else if (currentItemId === 'item-3') { // Verify page
                            $('#verify_error_message').text(message);
                        }
                    }
                    $.each(data, function(k, v){
                        $('input[name='+k+']').addClass('is-invalid');
                        $('#error_'+k).html(v);
                        $('.btn-form-save').prop('disabled', false);
                        $('.btn-form-save').html('Continue');
                        if (k == 'voucher_code') { // Payment page
                            $('.btn-form-save').html('Apply');
                        }
                    });
                } 
            });
        }        
    });
});